import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

interface Props {
  actionText?: string;
  buttonCategory?: string;
  buttonIcon?: string;
  buttonIsDropdown?: boolean;
  buttonText: string;
  category?: string;
  confirmText: string;
  confirmTitle: string;
  id: string;
  onConfirm: (values: { deletionReason?: string }) => Promise<boolean>;
  stopPropagation?: boolean;
  successMessage?: string;
}

const ConfirmDeleteButton = ({
  actionText,
  buttonCategory = 'danger',
  buttonIcon = 'trash-alt',
  buttonIsDropdown,
  buttonText,
  confirmText,
  confirmTitle,
  id,
  onConfirm,
  stopPropagation,
  successMessage
}: Props) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const handleConfirm = async (values: { deletionReason?: string }) => {
    try {
      const success = await onConfirm(values);

      if (success && successMessage) {
        dispatch(
          actions.addNotice({
            text: successMessage,
            type: 'success'
          })
        );
      } else if (!success) {
        return dispatch.handleErrorDispatch(null);
      }

      return success;
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
      return false;
    }
  };

  return (
    <ModalButtonWithForm
      buttonCategory={buttonCategory}
      buttonIcon={buttonIcon}
      buttonIsDropdown={buttonIsDropdown}
      buttonText={buttonText}
      modalActionText={actionText || messages.commonDelete}
      modalTitle={confirmTitle}
      onSubmit={handleConfirm}
      stopPropagation={stopPropagation}
    >
      {() => (
        <>
          <div>{confirmText}</div>
          <FormGroup htmlFor={id} label={messages.commonDeletionReason}>
            <Text
              field="deletionReason"
              id={id}
              maxLength={255}
              autocomplete="off"
              placeholder={messages.commonInputDeletionReason}
              required={true}
            />
          </FormGroup>
        </>
      )}
    </ModalButtonWithForm>
  );
};

export default ConfirmDeleteButton;
